import Maybe from 'graphql/tsutils/Maybe';
import { RegistrySummary } from '../generated/graphql';

const REGISTRY_TYPE_CASH = 3;

function registryInfo(registrySummary: Maybe<RegistrySummary>) {
  const hasTransactionalRegistry = registrySummary?.hasTransactionalRegistry;
  const hasCashFund = !!registrySummary?.totalCashFunds;
  const affiliateRegistries = registrySummary?.registries?.filter(r => {
    return !r?.isDeleted && !r?.hiddenWws && r?.registryType !== REGISTRY_TYPE_CASH;
  });
  const hasAffiliateRegistry = !!(affiliateRegistries && affiliateRegistries.length > 0);

  const hasTransactionalOrCashRegistry = hasTransactionalRegistry || hasCashFund;
  const hasAnyRegistry = hasTransactionalRegistry || hasCashFund || hasAffiliateRegistry;

  const registryTypes: string[] = [];
  if (hasAffiliateRegistry) registryTypes.push('affiliate');
  if (hasCashFund) registryTypes.push('cash');
  if (hasTransactionalRegistry) registryTypes.push('transactional');

  return {
    hasTransactionalRegistry,
    hasCashFund,
    hasAffiliateRegistry,
    hasTransactionalOrCashRegistry,
    hasAnyRegistry,
    registryTypes,
  };
}

export default registryInfo;
